import { Outlet, createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';

import { ServicePlanDetailHeader } from './_detail/-components/ServicePlanDetailHeader';

export const Route = createFileRoute(
  '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail',
)({
  component: ServicePlanDetail,
});

function ServicePlanDetail() {
  return (
    <VStack>
      <ServicePlanDetailHeader />
      <Outlet />
    </VStack>
  );
}
